// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__r3pu_","tutorial":"Links_tutorial__RPBSa","community":"Links_community__mthqP","link":"Links_link__3WDhT"};